// extracted by mini-css-extract-plugin
export default {"wrapper":"TransactionStatus_wrapper__8oC+i","eye":"TransactionStatus_eye__VMk6j","clipboardNotes":"TransactionStatus_clipboardNotes__O73FS"};